import { render } from "./TextArea.vue?vue&type=template&id=75cc27eb&scoped=true&bindings={\"value\":\"props\",\"name\":\"props\",\"label\":\"props\",\"handleChange\":\"setup\",\"handleBlur\":\"setup\",\"errorMessage\":\"setup\",\"inputValue\":\"setup\"}"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=75cc27eb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75cc27eb"

export default script